import { Helmet } from 'react-helmet-async'
import { HeroSection } from '@components/sections/Hero/Hero'
import { StatsSection } from '@components/sections/Stats/Stats'
import { WhatWeSupply } from '@components/sections/WhatWeSupply/WhatWeSupply'
import { ServicesGrid } from '@components/sections/ServicesGrid/ServicesGrid'
import { ProductsGrid } from '@components/sections/ProductsGrid/ProductsGrid'
import { WhyChooseSection } from '@components/sections/WhyChoose/WhyChoose'
import { ProjectsShowcase } from '@components/sections/ProjectsShowcase/ProjectsShowcase'
import { CertificationsMarquee } from '@components/sections/CertificationsMarquee/CertificationsMarquee'
import { CTASection } from '@components/sections/CTA/CTA'
import { siteConfig, generateOrganizationSchema } from '@constants/seo'

const Home = () => {
  return (
    <>
      <Helmet>
        <title>{siteConfig.title} | {siteConfig.tagline}</title>
        <meta name="description" content={siteConfig.description} />
        <meta name="keywords" content={siteConfig.keywords.join(', ')} />
        <meta name="robots" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1" />
        <link rel="canonical" href={siteConfig.url} />

        {/* Open Graph */}
        <meta property="og:title" content={`${siteConfig.name} | ${siteConfig.tagline}`} />
        <meta property="og:description" content={siteConfig.description} />
        <meta property="og:type" content="website" />
        <meta property="og:url" content={siteConfig.url} />
        <meta property="og:image" content="https://www.eonixa.in/og-image.jpg" />
        <meta property="og:site_name" content={siteConfig.name} />
        <meta property="og:locale" content="en_IN" />

        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={`${siteConfig.name} | ${siteConfig.tagline}`} />
        <meta name="twitter:description" content={siteConfig.description} />
        <meta name="twitter:image" content="https://www.eonixa.in/og-image.jpg" />

        {/* Structured Data */}
        <script type="application/ld+json">
          {JSON.stringify(generateOrganizationSchema())}
        </script>
      </Helmet>

      {/* Background is now global in App.tsx via GlobalBackground component */}
      <HeroSection />
      <StatsSection />
      <WhatWeSupply />
      <ServicesGrid />
      <ProductsGrid />
      <WhyChooseSection />
      <ProjectsShowcase />
      <CertificationsMarquee />
      <CTASection />
    </>
  )
}

export default Home